import { put, call, take, fork } from 'redux-saga/effects'
import { addSectionService } from 'src/api/course'
import { addSectionSuccess } from '../../reducers/course/action'
import { ADD_SECTION } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* addSectionFlow(payload) {
  try {
    const { entity, callback } = payload

    const response = yield call(addSectionService, entity)

    yield put(addSectionSuccess(response.data))
    yield put(operationSuccess())
    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* addSectionWatcher() {
  while (true) {
    const action = yield take(ADD_SECTION)
    const { payload } = action

    yield fork(generalSaga, addSectionFlow, payload)
  }
}
